import { useTheme } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";

const SEOProvider = () => {
  const theme = useTheme();

  return (
    <Helmet
      title="Lendzee | Application"
      htmlAttributes={{ lang: "en" }}
      meta={[
        {
          name: `description`,
          content: "",
        },
        {
          name: "theme-color",
          content: theme.palette.primary.main,
        },
      ]}
    />
  );
};

export default SEOProvider;
